import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

import { StyleProps } from './BooleanButton.types';

export const useButtonContentStyles = makeStyles<StyleProps>()(({ spacing }: Theme, { displayAsRow }) => ({
  root: {
    minWidth: 'auto',
  },
  markerPadding: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: spacing(1),
    paddingRight: spacing(1),
  },
  grid: {
    display: 'grid',
    justifyContent: 'space-between',
    height: '100%',
    gridTemplateColumns: displayAsRow ? 'auto' : 'auto auto',
    gridGap: spacing(displayAsRow ? 0.5 : 1),
    marginLeft: spacing(1),
  },
  noMargin: {
    margin: 0,
  },
}));

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.

export const useBooleanButtonStyles = makeStyles<{ bottomMargin: boolean }>()(
  ({ palette, shape, shadows, spacing }: Theme, { bottomMargin }) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      borderRadius: shape.borderRadius,
      margin: 0,
      boxShadow: shadows['1'],
      backgroundColor: palette.background.paper,
      color: palette.text.primary,
      paddingTop: spacing(2),
      paddingBottom: spacing(2),
      paddingLeft: spacing(1),
      paddingRight: spacing(1),
      marginBottom: bottomMargin ? spacing(1.5) : 0,

      '&:hover': {
        backgroundColor: palette.background.default,
      },

      '&.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: palette.primary.main,
        color: palette.primary.contrastText,
      },

      '&.Mui-disabled': {
        boxShadow: 'none',
        backgroundColor: palette.common.white,
      },
      '& .MuiLink-root': {
        textDecoration: 'underline',
      },
    },
    selected: {},
    disabled: {
      boxShadow: 'none',
      backgroundColor: palette.secondary.light,
    },
    dense: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  })
);
